import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import AppAnimate from "../../../components/AppAnimate";
import AppCard from "../../../components/layouts/components/AppCard";
import Grid from "@material-ui/core/Grid/Grid";
import {connect, setStore} from "trim-redux";
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
import Typography from "@material-ui/core/Typography/Typography";
import {currencySymbol, price} from "../../../../config/values";
import {updateRedux} from "../../../../config/Security";
import SubTitle from "../../../components/elements/SubTitle";
import moment from "jalali-moment";
import Divider from "@material-ui/core/Divider/Divider";
import FiberManualRecordRoundedIcon from '@material-ui/icons/FiberManualRecordRounded';
import SingleOrder from "./components/SingleOrder";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import TextField from "@material-ui/core/TextField/TextField";
import Button from "@material-ui/core/Button/Button";
import ReturnMoneyDialog from "../../wallet/ReturnMoneyDialog";
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';

class ViewOrder extends React.Component {

    state = {
        factor:null,
        SubmitLoading:false,
        id:this.props.match.params.id,
        loading:true
    };
    classes = this.props.classes;
    async componentDidMount(){
        await this.loadData();

    }
    componentDidUpdate(prevProps){
        if(this.state.id !== this.props.match.params.id){
            this.setState({
                id: this.props.match.params.id
            })
        }
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/factor/get/${this.state.id}`, config)
                .then(response => {
                    this.setState({
                        factor:response.data,
                        loading:false
                    })

                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }

    async handleRequest(){
        let { id} = this.state;
        let data = new FormData();
        data.append('id', id);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.post(`${defaultVariabls.url}/factor/pay`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.orderPayed, {
                    variant: 'success',
                });
                updateRedux();
                this.setState({
                    loading:true,
                    SubmitLoading: false,
                });
                this.loadData();

            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.orderPayingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false
                });
            });

    }

    handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        this.handleRequest();

    }
    async handleChangeFactorStatus(e){
        let {status,id} = this.state.factor;
        let new_status = e.target.value;
        if(new_status !== status){
            this.setState({
                loading:true,
            });
            let data = new FormData();
            data.append('id', id);
            data.append('status', new_status);

            let loginToken = localStorage.getItem('ACT');
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.post(`${defaultVariabls.url}/factor/change_status`, data, config)
                .then(response => {
                    this.props.enqueueSnackbar(Translate.dataEdited, {
                        variant: 'success',
                    });
                    this.loadData();
                })
                .catch(error => {
                    console.log(error.response)
                    if(error.response.status == 403){
                        if(error.response.data === "orders_status_problem"){
                            this.props.enqueueSnackbar(Translate.firstCheckOrdersStatus, {
                                variant: 'warning',
                            });
                        }
                    }else{
                        this.props.enqueueSnackbar(Translate.dataEditingFailed, {
                            variant: 'error',
                        });
                    }

                    this.setState({
                        loading:false,
                        SubmitLoading: false,
                    });
                });
        }

    }
    async reload(){
        await this.setState({
            loading:true
        })
        await this.loadData()
    }
    render(){
        let {factor,SubmitLoading} = this.state;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.manageOrder}>
                {

                    <Grid container spacing={2} justify="center">
                        <Grid item xs={12} md={11}>
                            <AppCard
                                title={Translate.manageOrder}
                                action={
                                    <BreadCrumbs  firstText={Translate.ordersList} firstLink="/manage/orders" secondText={Translate.manageOrder}/>
                                }>
                                {
                                    this.state.loading ?
                                        <AppCardLoaderFields/>
                                        :
                                        <Grid container spacing={2} justify="center" alignItems="center">
                                            <Grid item xs={12} style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                                                <SubTitle align="left">{Translate.orderDetails}</SubTitle>
                                                {
                                                    (factor.status !== "not_payed" && factor.status !== "need_verification"&& factor.status !== "rejected") &&
                                                    <Button
                                                        color="primary"
                                                        component={"a"}
                                                        href={`${defaultVariabls.website}/view/invoice/${factor.number}`}
                                                        target="_blank"
                                                        size="small"
                                                        variant="outlined"
                                                        startIcon={<ChevronLeftRoundedIcon/>}
                                                    >
                                                        {Translate.viewInvoice}
                                                    </Button>
                                                }
                                            </Grid>
                                            <Grid item xs={12} className="order-items-action">
                                                <div className="order-items-holder">
                                                    <Typography>{Translate.factor_status} <span className="result" style={{color: factor.status === "not_payed" || factor.status === "rejected" ? "#f82e4e" : ''}}>{Translate[factor.status]}</span> </Typography>
                                                    <Typography>
                                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                                    </Typography>
                                                    <Typography>{Translate.factor_number} <span className="result">{factor.number}</span></Typography>
                                                    <Typography>
                                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                                    </Typography>
                                                    <Typography>
                                                        {Translate.created_at_factor}
                                                        <span className="result">
                                                            {`${moment(factor.created_at).locale('fa').format( 'YYYY/M/D')}`}
                                                        </span>
                                                    </Typography>
                                                </div>
                                                {
                                                    factor.status !== "not_payed" && factor.status !== "rejected" ?
                                                        <div className="order-items-holder mt-15">
                                                            {
                                                                factor.status === "need_verification" ?
                                                                    <TextField
                                                                        select
                                                                        size="small"
                                                                        label={Translate.changeFactorStatus}
                                                                        value={factor.status}
                                                                        onChange={(e) => this.handleChangeFactorStatus(e)}
                                                                        variant="outlined"
                                                                        helperText={Translate.changeStatusHelper}
                                                                    >
                                                                        <MenuItem value={"need_verification"}>{Translate.need_verification}</MenuItem>
                                                                        <MenuItem value={"not_payed"}>{Translate.confirmToPay}</MenuItem>
                                                                        <MenuItem value={"rejected"}>{Translate.rejected}</MenuItem>
                                                                    </TextField>
                                                                    :
                                                                    <TextField
                                                                        select
                                                                        size="small"
                                                                        label={Translate.changeFactorStatus}
                                                                        value={factor.status}
                                                                        onChange={(e) => this.handleChangeFactorStatus(e)}
                                                                        variant="outlined"
                                                                        helperText={Translate.changeStatusHelper}
                                                                    >
                                                                        <MenuItem value={"gathering"}>{Translate.gathering}</MenuItem>
                                                                        <MenuItem value={"sending"}>{Translate.sending}</MenuItem>
                                                                        <MenuItem value={"done"}>{Translate.done}</MenuItem>
                                                                        <MenuItem value={"rejected"}>{Translate.rejected}</MenuItem>
                                                                    </TextField>
                                                            }
                                                        </div>
                                                        : null
                                                }

                                            </Grid>

                                            {
                                                (factor.status !== "not_payed" && factor.status !== "need_verification") ?
                                                    (factor.money_returned === 0 && factor.status === "rejected") &&
                                                    <Grid item xs={12}>
                                                    <ReturnMoneyDialog factor={factor} reload={() => this.loadData()}/>
                                                    </Grid>
                                                : null
                                            }

                                            <Grid item xs={12}>
                                                <Divider/>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <div className="order-items-holder mb-15">
                                                    <Typography>{Translate.user_delivery} <span className="result">{factor.user.first_name} {factor.user.last_name}</span></Typography>
                                                    <Typography>
                                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                                    </Typography>
                                                    <Typography>{Translate.mobileNumber} <span className="result">{factor.user.mobile}</span></Typography>
                                                </div>
                                                <div className="order-items-holder">
                                                    <Typography>{Translate.address} <span className="result">{factor.address.province} / {factor.address.city}، {factor.address.address}، {Translate.postal_code} {factor.address.postal_code}.  </span></Typography>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider/>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <div className="order-items-holder">
                                                    <Typography>{Translate.priceName}<span className="result">{price(factor.total_price_payed  - factor.transfer_price)} {currencySymbol}</span></Typography>
                                                    <Typography>
                                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                                    </Typography>
                                                    <Typography>{Translate.transferPrice}<span className="result">{price(factor.transfer_price)} {currencySymbol}</span></Typography>
                                                    <Typography>
                                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                                    </Typography>
                                                    <Typography>{Translate.discounts} <span className="result"> {price(factor.total_discount_price)} {currencySymbol}</span></Typography>
                                                    <Typography>
                                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                                    </Typography>
                                                    <Typography>{Translate.total_commission} <span className="result"> {price(factor.commission)} {currencySymbol}</span></Typography>
                                                </div>
                                                {
                                                    !!factor.discount_name &&
                                                    <div className="order-items-holder mt-15">
                                                        <Typography>{Translate.discount_code} <span className="result"> {price(factor.total_discount_code_price)} {currencySymbol} - {factor.discount_name}</span></Typography>
                                                    </div>
                                                }
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider/>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <SubTitle color="primary" align="left">{Translate.shopsList}</SubTitle>
                                            </Grid>
                                            <Grid item xs={12}>
                                                {
                                                    factor.orders.map((item,index) => (
                                                        <>
                                                            <SingleOrder factor={factor} key={index} item={item} reload={() => this.reload()}/>
                                                            <Divider/>
                                                        </>
                                                    ))
                                                }
                                            </Grid>
                                        </Grid>
                                }
                            </AppCard>
                        </Grid>
                    </Grid>
                }
            </AppAnimate>

        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(ViewOrder))));